export default __webpack_public_path__ + "static/media/15.74de40d0.png";